module.exports = "/_next/static/images/row3-4-2x-8fbe6b3cc273d4ae9a146837f9db77b6.png";